'use strict';
import {createEventHandler, mapPropsStream} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import {AssetViewBannerView} from './AssetViewBannerView';


export const StreamedComponent = (props$) => {
  const {
    handler: onClick,
    stream: click$,
  } = createEventHandler();

  click$
    .withLatestFrom(props$)
    .debounceTime(300)
    .takeUntil(props$.last())
    .subscribe(([ev, props]) => {
      // Do Something
      props.onClick();
    });

  return props$
    .combineLatest(
      (props) => ({
        ...props,
        onClick,
      }));
};

export const AssetViewBannerComponent = mapPropsStream(StreamedComponent)(AssetViewBannerView);



// WEBPACK FOOTER //
// ./src/js/assets/components/AssetViewBanner/AssetViewBannerComponent.js